const ACTIVATION_TYPE = "ACTIVATION_TYPE";
const ACTIVATION_CASE = "ACTIVATION_CASE";
const ADD_ACTIVATION = "ADD_ACTIVATION";
const EDIT_ACTIVATION = "EDIT_ACTIVATION";
const ACTIVATION_MARKET = "ACTIVATION_MARKET";
const LOAD_ACTIVATIONCREATE = "LOAD_ACTIVATIONCREATE";
const UPDATE_USER = "UPDATE_USER";
const ADD_USER = "ADD_USER";
const SET_USERS = "SET_USERS";
const SET_ROLES = "SET_ROLES";
const SET_UNAUTHORIZE_ROLES = "SET_UNAUTHORIZE_ROLES";
const SET_ENTITIES = "SET_ENTITIES";
const SET_ENTITY_TYPES = "SET_ENTITY_TYPES";
const SET_INFLUENCERS = "SET_INFLUENCERS";
const GET_ALL_ACTIVATIONS = "GET_ALL_ACTIVATIONS ";
const GET_ALL_KEYWORDS = "GET_ALL_KEYWORDS ";
const GET_ALL_HASHTAGS = "GET_ALL_HASHTAGS ";
const ACTIVATION_BRAND = "ACTIVATION_BRAND ";
const ACTIVATION_BRAND_QUALITY = "ACTIVATION_BRAND_QUALITY";
const STORE_ACTIVATION = "STORE_ACTIVATION ";
const ADD_BRAND = "ADD_BRAND";
const ADD_BRANDQUALITY = "ADD_BRANDQUALITY";
const ADD_MARKET = "ADD_MARKET";
const ADD_INFLUENCER = "ADD_INFLUENCER";
const SET_ACTIVATION_CAN_PROVIDER_ACCESS = "SET_ACTIVATION_CAN_PROVIDER_ACCESS";
const SET_ACTIVATION_IS_LIVE = "SET_ACTIVATION_IS_LIVE";
const SET_ACTIVATION_DELETE = "SET_ACTIVATION_DELETE";
const LOAD_ACTIVATION_COMMENTS = "LOAD_ACTIVATION_COMMENTS";
const ADD_ACTIVATION_COMMENT = "ADD_ACTIVATION_COMMENT";
const ADD_CHILD_MARKET = "ADD_CHILD_MARKET";
const UPLOAD_FILE = "UPLOAD_FILE";
const CLEAR_DASHBOARD = "CLEAR_DASHBOARD";
const ADD_ACTIVATIONCREATE = "ADD_ACTIVATIONCREATE";
const GET_INFLUENCERS_FILE_TEMPLATE = "GET_INFLUENCERS_FILE_TEMPLATE";
const GET_INFLUENCERS_FILE = "GET_INFLUENCERS_FILE";
const RESET_INFLUENCERS_FILE = "RESET_INFLUENCERS_FILE";
const LOAD_ACTIVATIONS_USERS = "LOAD_ACTIVATIONS_USERS";
const UPSERT_ACTIVATION_USERS = "UPSERT_ACTIVATION_USERS";
const ADD_PR_AFFILIATE = "ADD_PR_AFFILIATE";
const ACTIVATION_PR_AFFILIATE = "ACTIVATION_PR_AFFILIATE";

export {
    ADD_USER,
    UPDATE_USER,
    ACTIVATION_TYPE,
    ACTIVATION_CASE,
    ADD_ACTIVATION,
    EDIT_ACTIVATION,
    ACTIVATION_MARKET,
    ADD_CHILD_MARKET,
    LOAD_ACTIVATIONCREATE,
    SET_USERS,
    SET_ROLES,
    SET_UNAUTHORIZE_ROLES,
    SET_ENTITIES,
    SET_ENTITY_TYPES,
    SET_INFLUENCERS,
    GET_ALL_ACTIVATIONS,
    GET_ALL_KEYWORDS,
    GET_ALL_HASHTAGS,
    ACTIVATION_BRAND,
    ACTIVATION_BRAND_QUALITY,
    STORE_ACTIVATION,
    ADD_BRAND,
    ADD_BRANDQUALITY,
    ADD_MARKET,
    ADD_INFLUENCER,
    SET_ACTIVATION_CAN_PROVIDER_ACCESS,
    SET_ACTIVATION_IS_LIVE,
    SET_ACTIVATION_DELETE,
    LOAD_ACTIVATION_COMMENTS,
    ADD_ACTIVATION_COMMENT,
    UPLOAD_FILE,
    CLEAR_DASHBOARD,
    ADD_ACTIVATIONCREATE,
    GET_INFLUENCERS_FILE_TEMPLATE,
    GET_INFLUENCERS_FILE,
    RESET_INFLUENCERS_FILE,
    LOAD_ACTIVATIONS_USERS,
    UPSERT_ACTIVATION_USERS,
    ADD_PR_AFFILIATE,
    ACTIVATION_PR_AFFILIATE,
};
